import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@src/design-system/dropdown-menu';
import { ArrowDown2 } from 'iconsax-react';

import { DynamicFilterFieldSelector } from './dynamic-filter-field-selector';
import { DynamicOperatorDropdown } from './dynamic-operator-dropdown';
import { DynamicFilterValueInput } from './dynamic-filter-value-input';

import { useTableViewHelpers } from '@design-system/molecules/ticlick-table/hooks/use-table-view-helpers';
import { DeleteDynamicFilterBtn } from './delete-dynamic-filter-button';
import { cn } from '@src/design-system/helpers';
import { inputVariants } from '@src/design-system/input';

import type { TDynamicFilter } from '@shared/types/dynamic-filter';

export function DynamicFilterRow({
  position,
  dynamicFilter,
}: {
  dynamicFilter: TDynamicFilter;
  position: number;
}) {
  const { updateDynamicFilter } = useTableViewHelpers();

  return (
    <div className='grid grid-cols-[150px_80px_150px_max-content] items-center gap-2'>
      <DropdownMenu>
        <DropdownMenuTrigger
          className={cn(
            'text-sm relative cursor-pointer items-center',
            inputVariants({ size: 'sm' })
          )}
        >
          <span className='w-[90%] text-start truncate'>
            {dynamicFilter.field?.title ? dynamicFilter.field?.title : 'Select'}
          </span>
          <ArrowDown2
            size={16}
            className='text-primary-1000 absolute right-2 top-1/2 -translate-y-1/2'
          />
        </DropdownMenuTrigger>

        <DropdownMenuContent
          align='start'
          isInModal
          className='p-2'
        >
          <DynamicFilterFieldSelector index={position} />
        </DropdownMenuContent>
      </DropdownMenu>

      {dynamicFilter.field && dynamicFilter.operator && (
        <DynamicOperatorDropdown
          dynamicField={dynamicFilter}
          onChange={(op) =>
            updateDynamicFilter(
              {
                operator: op,
              },
              position
            )
          }
          currentOperator={dynamicFilter.operator}
          questionType={dynamicFilter.field.type}
        />
      )}

      {dynamicFilter.field && (
        <DynamicFilterValueInput
          dynamicField={dynamicFilter}
          index={position}
        />
      )}

      <DeleteDynamicFilterBtn position={position} />
    </div>
  );
}
